import { SkeletonDefault } from '../../ui/src/components/atoms/skeleton/SkeletonDefault'

export const PlaceholderParagraph = ({ className }: { className?: string }) => (
  <SkeletonDefault className={className} />
)
